export default __webpack_public_path__ + "static/media/illest.3144c59b.png";